import React, { useState } from "react";
import "./login.scss";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Login } from "../../services/userService";
import { toast } from "react-toastify";
import Logo from "../../assets/images/logo.svg";
import ShowPass from "../../assets/images/showPass.svg";
import HidePass from "../../assets/images/hidePass.svg";
import SubmitButton from "../submitButton/submitButton";

function LoginComponent() {
  let navigate = useNavigate();
  const [showPassword, setShowpassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loading, setLoadig] = useState(false);

  const handlePasswordVisibility = () => {
    setShowpassword(!showPassword);
  };

  const handlePassword = (e) => {
    setPasswordError(false);
    setPassword(e.target.value);
  };

  const handleEmail = (e) => {
    setEmailError(false);
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setEmailError(true);
    }
    if (password === "") {
      setPasswordError(true);
    }
    if (email !== "" && password !== "") {
      try {
        setLoadig(true);
        let res = await Login(email.toLocaleLowerCase(), password);
        setLoadig(false);
        localStorage.setItem("token", res.token);
        localStorage.setItem("fullname", res.fullname);
        localStorage.setItem("role", res.role);
        localStorage.removeItem("searched");
        navigate("/dashboard");
      } catch (err) {
        setLoadig(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  };

  return (
    <div className="login">
      <div className="loginContent">
        <div className="content">
          <img src={Logo} alt="logo" />
          <div className="title">کارماراتو مدیریت کن</div>
          <p>ایمیل و کلمه عبور خودت رو وارد کن</p>
        </div>
        <form>
          <label
            className={emailError ? "labelError" : ""}
            htmlFor="email"
          >
            ایمیل
          </label>
          <input
            className={emailError ? "inputError" : ""}
            type="email"
            onChange={(e) => handleEmail(e)}
            id="email"
            name="email"
            placeholder="ایمیلت رو اینجا بنویس"
            // autoFocus
          />
          <label
            className={passwordError ? "passwordLabelError" : ""}
            htmlFor="password"
          >
            کلمه عبور
          </label>
          <div
            className={passwordError ? "passwordError" : "passwordContainer"}
          >
            <input
              type={showPassword ? "text" : "password"}
              onChange={handlePassword}
              id="password"
              name="password"
              placeholder="کلمه عبورت رو اینجا بنویس"
            />
            <img
              src={showPassword ? ShowPass : HidePass}
              onClick={handlePasswordVisibility}
              alt="icon"
            />
          </div>
          <div className="options flex justify-left rtl">
            <div  onClick={() => {
              navigate("/forgotPassword");
            }}>
              کلمه عبورم یادم نیست!
            </div>
          </div>
          <SubmitButton onClick={handleSubmit} text="ورود به کارمارا" loading={loading} />
          <div className="options flex justify-center rtl">
            <div  onClick={() => {
              navigate("/signup");
            }}>
              می خوام ثبت نام کنم
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default LoginComponent;
